module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/grid/flex-align-self/flex-align-self.component.scss
// module id = ./src/app/features/grid/flex-align-self/flex-align-self.component.scss
// module chunks = main